import { Auth0Provider } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import { AUTH0_DOMAIN, AUTH0_CLIENT_ID, AUTH0_AUDIENCE, AUTH0_REDIRECT_URI } from '../services/constants.js'

// Wraps Auth0Provider so we can pass React Router's navigate into
// onRedirectCallback. Without this, after Auth0 returns ?code=&state= to the
// app, the SDK's default replaceState lands the user on whichever path the
// flow started from (e.g. /signup), where the SignUp page would briefly try
// to redirect again before realising the user is now authenticated. Sending
// everyone to "/" (Dashboard) post-auth is deterministic and matches what a
// brand-new signup user expects to see.
const Auth0ProviderWithNavigate = ({ children }) => {
  const navigate = useNavigate()

  const onRedirectCallback = () => {
    // Always land on the dashboard after successful auth, regardless of where
    // the redirect was kicked off from. ProtectedRoute / AuthInitializer take
    // it from there.
    navigate('/', { replace: true })
  }

  return (
    <Auth0Provider
      domain={AUTH0_DOMAIN}
      clientId={AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: AUTH0_REDIRECT_URI,
        audience: AUTH0_AUDIENCE,
        scope: 'openid profile email offline_access read:vehicles write:vehicles delete:vehicles',
      }}
      onRedirectCallback={onRedirectCallback}
    >
      {children}
    </Auth0Provider>
  )
}

export default Auth0ProviderWithNavigate
